import { Typography } from '@mui/material';

interface TypographyProps {
  children: string | JSX.Element;
}

export const Body8VariantTypography = ({ children }: TypographyProps) => (
  <Typography variant='body8' >{children}</Typography>
);
